export enum InvitationState {
    ExistingUserInviteApplied = "ExistingUserInviteApplied",
    UserCreated = "UserCreated"
}